import { SHIPPING_MODEL, shippingModel } from 'core';
import { Cart as CartProps, CART_SHIPPING_MODEL_VIEW } from 'core/domains';

import type { Dispatch } from 'redux';

export const onClickByStep = (
  step: string,
  selectedShippingModel: CartProps['current']['shippingModel'],
  shippingModelType: string,
  toggleActive: boolean,
  dispatch: Dispatch,
  handlers: {
    setShippingModel: (selected: CartProps['current']['shippingModel']) => void;
    setShippingModelStep: ({
      step,
      defaultShippingModelCode,
    }: {
      step: string;
      defaultShippingModelCode?: number;
    }) => void;
  },
  address?: string,
) => {
  const isResellerShippingModel =
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.KEY_ACCOUNT_ORDER_EXPRESS ||
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.KEY_ACCOUNT_RETROACTIVE ||
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.KEY_ACCOUNT ||
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.ORDER_EXPRESS ||
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.RETROACTIVE_RESELLER ||
    selectedShippingModel?.businessModelCode === SHIPPING_MODEL.RESELLER;

  const hasShouldShowOptions =
    isResellerShippingModel && !shippingModelType.includes('pickupStore');

  const payload = {
    address: address || '',
    distributionCenterCode: selectedShippingModel.distributionCenterCode ?? 0,
    businessModelCode: selectedShippingModel.businessModelCode ?? 0,
    isWithdrawal: selectedShippingModel.iswithdrawal,
  };

  switch (step) {
    case CART_SHIPPING_MODEL_VIEW.OPTIONS: {
      if (hasShouldShowOptions) {
        return toggleActive
          ? dispatch(shippingModel.actions.currentDeliveryModeFetch.request(payload))
          : handlers.setShippingModel(selectedShippingModel);
      } else {
        return handlers.setShippingModelStep({
          step: CART_SHIPPING_MODEL_VIEW.SELECT_PICKUP_STORE,
        });
      }
    }
    case CART_SHIPPING_MODEL_VIEW.SELECT_PICKUP_STORE: {
      return toggleActive
        ? dispatch(shippingModel.actions.currentDeliveryModeFetch.request(payload))
        : handlers.setShippingModel(selectedShippingModel);
    }

    default: {
      break;
    }
  }
};
